
// slideshow
function initHero(){
 const hero=document.querySelector('.hero'); if(!hero) return;
 const slides=[...hero.querySelectorAll('.slide')],dots=[...hero.querySelectorAll('.dot')];let cur=0,auto;
 window.goSlide=i=>{slides[cur].classList.remove('on');if(dots[cur])dots[cur].classList.remove('on');cur=(i+slides.length)%slides.length;slides[cur].classList.add('on');if(dots[cur])dots[cur].classList.add('on')};
 window.slide=d=>goSlide(cur+d);
 const start=()=>auto=setInterval(()=>slide(1),5200);start();
 hero.addEventListener('mouseenter',()=>clearInterval(auto));
 hero.addEventListener('mouseleave',start);
}
function rail(id,d){const el=document.getElementById(id);if(el)el.scrollBy({left:d*320,behavior:'smooth'})}
window.rail=rail;
// reveals
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
// cart count
const countEl=document.getElementById('count');
function refreshCount(){fetch('/cart.js').then(r=>r.json()).then(c=>{if(countEl){countEl.textContent=c.item_count;}}).catch(()=>{})}
refreshCount();
function bump(){if(!countEl)return;countEl.classList.add('bump');setTimeout(()=>countEl.classList.remove('bump'),300)}
// quick add (real when variant id present, visual demo otherwise)
document.addEventListener('click',e=>{
 const b=e.target.closest('.quick'); if(!b) return;
 const v=b.dataset.variant;
 if(v){b.textContent='Adding…';
   fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:Number(v),quantity:1})})
   .then(r=>{if(!r.ok)throw 0;return r.json()}).then(()=>{refreshCount();bump();b.textContent='Added ✦';setTimeout(()=>b.textContent='Quick Add +',1400)})
   .catch(()=>{b.textContent='Unavailable';setTimeout(()=>b.textContent='Quick Add +',1400)});
 } else { if(countEl){countEl.textContent=(Number(countEl.textContent)||0)+1;} bump(); }
});
initHero();
